import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { Page, OtherServices, FooterSmall } from "@packages/ui";
import CheckinForm from "../../components/CheckinForm";
import AdditionalDriverCheckinLoginForm from "../../components/AdditionalDriverCheckin";

import * as appActions from "src/actions/appActions";
import * as checkinActions from "src/actions/checkinActions";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import getServiceFromUrl from "../../utils/getServiceFromUrl";
import * as constants from "../../utils/constants";

import { Box, Container, makeStyles } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import {apiURI} from "../../env";
import getCountryFromURL from "src/utils/getCountryFromUrl";



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
  },
  tile: {
    width: "100%",
  },
  container: {
    backgroundColor: "white",
    paddingTop: 35,
    paddingBottom: 20,
    borderRadius: 5,
    [theme.breakpoints.up("xs")]: { border: "none", borderRadius: 0 },
    [theme.breakpoints.up("sm")]: {
      border: "solid 1px lightgrey",
      borderBottom: `solid 5px ${theme.palette.primary.main}`,
      borderRadius: 5,
    },
  },
  box: {
    [theme.breakpoints.up("xs")]: {
      marginTop: -30,
    },
    [theme.breakpoints.up("md")]: {
      marginTop: -80,
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: -110,
    },
    [theme.breakpoints.up("xl")]: {
      marginTop: -150,
    },
  },
  tileDiv: {},
}));

const CheckInView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const auth = useSelector((state) => ({ ...state.auth }));
  const rentals = useSelector((state) => ({ ...state.app.rentals }));
  const checkin = useSelector((state) => state.checkin);
  const navigate = useNavigate();
  const brand = getBrandFromUrl();
  const country = getCountryFromURL();
  const service = getServiceFromUrl();
  const urlParams = new URLSearchParams(window.location.search);
  const resNo = urlParams.get("b") ? urlParams.get("b") : "";
  const isGenericCheckin = urlParams.get("genericCheckin") ? urlParams.get("genericCheckin") : false;

  const isAdditionalDriver = window.location.pathname.includes("additional") || checkin.isAdditionalDriver;

  const randomNumber = Math.random();

  useEffect(() => {
    if (auth.success && _.isEmpty(rentals)) {
      dispatch(appActions.getRentals(auth));      
    }
  }, [auth.success]);

  useEffect(() => {
    if (!_.isEmpty(rentals)) {
      navigate("/app/rentalhistory", { replace: true });
    }
  }, [rentals]);

  useEffect(() => {
    if (isGenericCheckin) {
      dispatch(checkinActions.setIsGenericCheckin({isGenericCheckin:true}));
    }
  }, []);

  const otherService = brand =="Dollar" || brand == "Thrifty" ? <div></div> : <OtherServices brand={brand} country={country.toLowerCase()} />

  return (
    <Page
      className={classes.root}
      title="Login - My Journey Portal"
      style={{ background: "white", textAlign: "center" }}
    >
      <img
        src={
          brand === "Ace"
            ? service === "MJP"
              ? constants.ACE_LOGIN_BANNER
              : constants.ACE_ONLINE_CHECKIN_BANNER
            : brand === "Firefly"
            ? constants.FIREFLY_LOGIN_BANNER
            : brand === "Dollar" ? service === "MJP" ? constants.DOLLAR_LOGIN_BANNER : constants.DOLLAR_ONLINE_CHECKIN_BANNER
            : brand === "Thrifty" ? service === "MJP" ? constants.THRIFTY_LOGIN_BANNER : constants.THRIFTY_ONLINE_CHECKIN_BANNER
            : service === "MJP" ? constants.HERTZ_LOGIN_BANNER : constants.HERTZ_ONLINE_CHECKIN_LOGIN_BANNER
        }
        width="100%"
      />

      {(resNo != "" && (!_.get(checkin,'auth.success',false))) &&  <img
       src={`${apiURI}/pixel/${window.location.pathname.replace(/\//g,'_')}.png?b=${resNo}&a=${"click"}&country=${getCountryFromURL()}&c=${randomNumber}&brand=${brand}&t=${isAdditionalDriver? "additional_driver":"primary_driver"}`}
       style={{display:'none'}}
       /> 
       }

      <Box display="flex" flexDirection="row" justifyContent="center" className={classes.box}>
        <Container maxWidth="sm" className={classes.container}>
          {isAdditionalDriver? <AdditionalDriverCheckinLoginForm resNo={resNo} brand={brand} />:<CheckinForm resNo={resNo} brand={brand} />}
          <Divider style={{ marginTop: 50, marginBottom: 40 }} />
          {otherService}
          <FooterSmall brand={brand} />
        </Container>
      </Box>
      <div style={{ height: 50 }}></div>
    </Page>
  );
};

export default CheckInView;
